<template>
  <section class="s-btn" >
    <div  class="right point" :style="btnStyle">{{textWord}}</div>
  </section>
</template>
<script>

export default {
  /******************************************
  ** 创建产品按钮组件
  * @description 创建产品按钮
  * @author ah
  *****************************************
  prop1          <type>            <属性描述>
  ave            string             背景色
  width          Number             按钮宽度
  height         Number             按钮高度
  color          string             字体颜色
  lineheight    Number             按钮行高
  *****************************************/
  name: 'SButton',
  components: {},
  props: {
    ave: {
      type: String,
      default () {
        return '{"RGB":"#276BEE"}'
      }
    },
    width: {
      type: String,
      default () {
        // return '168'
        return '0.84'
      }
    },
    height: {
      type: String,
      default () {
        // return '40'
        return '0.2'
      }
    },
    lineHeight: {
      type: String,
      default () {
        // return '40'
        return '0.2'
      }
    },
    textWord: {
      type: String,
      default: '哈哈哈'
    },
    color: {
      type: String,
      default () {
        return '{"RGB":"#FFF"}'
      }
    },
    // backgroundColor: {
    //   type: String,
    //   default () {
    //     return '{"RGB":"#FFF"}'
    //   }
    // },
    border: {
      type: String,
      default: 'solid 1px #276BEE'
    }
  },
  data () {
    return {
      btnStyle: {
        width: this.width + 'rem',
        height: this.height + 'rem',
        textWord: this.textWord,
        // background: this.ave,
        color: this.color,
        backgroundColor: this.ave,
        lineHeight: this.lineHeight + 'rem',
        border: this.border
      }
    }
  },
  computed: {},
  methods: {

  }
}
</script>
<style lang="less" scoped>
.right{
  text-align: center;
  // border: solid 1px #276BEE;
  border-radius:4px;
  // margin-bottom:20px;
  transition: all 0.3s;
  // font-size:16px;
  font-size:0.07rem;
  // &:hover{
  //   color:rgb(8, 63, 168) !important;
  //    background-color: #fff!important;
  // }
}
// .right:hover {
//      background-color: #276BEE!important;
//     color: #fff!important;
// }
</style>



// WEBPACK FOOTER //
// src/components/SButton.vue